import { Component } from "@angular/core";

@Component({
    selector: 'app-oncall',
    templateUrl: './oncall.component.html',
    standalone: false
})
export class OnCallComponent {}